import { PlanStatusCheckIcon } from "@/features/overview/components/plan-status-circle/plan-status-check-icon";
import { WEEKDAY_SHORT_LABELS, Weekday } from "@/features/meal-plan/constants/weekdays";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { format } from "date-fns";
import { memo } from "react";

interface DayItemProps {
  day: { day: string; date?: Date; dateKey: string; isAllTickedOff?: boolean };
  dateKey: string;
  isSelected: boolean;
  isChecked: boolean;
  isDisabled?: boolean;
  onSelectDate: (day: string, dateKey: string) => void;
  theme?: "default" | "v2";
}

export const DayItem = memo(function DayItem({
  day,
  dateKey,
  isSelected,
  isChecked,
  isDisabled = false,
  onSelectDate,
  theme = "default",
}: DayItemProps) {
  const getDateLabel = () => {
    if (isChecked) {
      return <PlanStatusCheckIcon bgColour="#33DDA5" checkColour="white" className="h-5 w-5" />;
    }
    return day.date ? format(day.date, "dd") : "";
  };
  return (
    <button
      key={day.day}
      data-date-key={dateKey}
      onClick={() => !isDisabled && onSelectDate(day.day, day.dateKey)}
      disabled={isDisabled}
      className={cn(
        "min-w-13 rounded-[10px] p-2.5 transition-all duration-200",
        "flex flex-col items-center justify-center gap-2",
        "hover:bg-gray-100 active:bg-gray-100",
        {
          "bg-[linear-gradient(180deg,#60418A_0%,#191124_474.2%)] text-white":
            isSelected && !isDisabled && theme === "default",
          "bg-[linear-gradient(180deg,#181d27_0%,#0d1118_100%)] text-white":
            isSelected && !isDisabled && theme === "v2",
          "bg-transparent text-black": !isSelected && !isDisabled,
          "cursor-not-allowed text-gray-400 opacity-30": isDisabled,
        },
      )}
    >
      <p
        className={cn(textVariants.bodySingleLine, "!font-light", {
          "text-white": isSelected,
          "text-black": !isSelected,
        })}
      >
        {WEEKDAY_SHORT_LABELS[day.day.toLowerCase() as Weekday]}
      </p>
      {getDateLabel()}
    </button>
  );
});
